module.exports = __webpack_public_path__ + "media/images/cv/screenshot_hangman-7bef5ff9e87665dc41555752fe13b60e.jpg";